import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import {
  collection,
  doc,
  getFirestore,
  orderBy,
  query,
  where,
} from "firebase/firestore";
import { getFunctions } from "firebase/functions";

const firebaseConfig = {
  apiKey: process.env.NEXT_PUBLIC_firebase_apiKey,
  authDomain: process.env.NEXT_PUBLIC_firebase_authDomain,
  projectId: process.env.NEXT_PUBLIC_firebase_projectId,
  storageBucket: process.env.NEXT_PUBLIC_firebase_storageBucket,
  messagingSenderId: process.env.NEXT_PUBLIC_firebase_messagingSenderId,
  appId: process.env.NEXT_PUBLIC_firebase_appId,
};

export const app = initializeApp(firebaseConfig);
export const firebaseAuth = getAuth();
export const functions = getFunctions();

export const getProfileRef = (uid) =>
  uid ? doc(getFirestore(), "profiles", uid) : null;

export const getBriefRef = (uid) =>
  uid ? doc(getFirestore(), "briefs", uid) : null;

export const getCampaignRef = (uid) =>
  uid ? doc(getFirestore(), "campaigns", uid) : null;

export const getSocialPostRef = (uid) =>
  uid ? doc(getFirestore(), "socialposts", uid) : null;

export const getCampaignQuery = (uid, conditons) => {
  const filters = [where("user", "==", uid), orderBy("createdAt", "desc")];
  conditons && filters.push(conditons);

  return uid
    ? query(collection(getFirestore(app), "campaigns"), ...filters)
    : null;
};

export const getPostsQuery = (postIds, conditons) => {
  if (!postIds) return null;

  const idList = postIds.split(",");

  const filters = [where("id", "in", idList)];
  conditons && filters.push(conditons);

  return query(collection(getFirestore(app), "socialposts"), ...filters);
};
